module.exports = __webpack_public_path__ + "static/media/banner01.2b5d0a73.jpg";